var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "plus_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    transform: "translate(34 -173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plus_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path0_stroke",
    transform: "translate(-33 174)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path1_stroke",
    transform: "translate(-28.5556 184)",
    fill: "#868686"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path2_stroke",
    transform: "translate(-23 178.444)",
    fill: "#868686"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path0_stroke",
    d: "M 19.5 10C 19.5 15.2467 15.2467 19.5 10 19.5L 10 20.5C 15.799 20.5 20.5 15.799 20.5 10L 19.5 10ZM 10 19.5C 4.75329 19.5 0.5 15.2467 0.5 10L -0.5 10C -0.5 15.799 4.20101 20.5 10 20.5L 10 19.5ZM 0.5 10C 0.5 4.75329 4.75329 0.5 10 0.5L 10 -0.5C 4.20101 -0.5 -0.5 4.20101 -0.5 10L 0.5 10ZM 10 0.5C 15.2467 0.5 19.5 4.75329 19.5 10L 20.5 10C 20.5 4.20101 15.799 -0.5 10 -0.5L 10 0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1_stroke",
    d: "M 0 -0.5C -0.276142 -0.5 -0.5 -0.276142 -0.5 0C -0.5 0.276142 -0.276142 0.5 0 0.5L 0 -0.5ZM 11.1111 0.5C 11.3873 0.5 11.6111 0.276142 11.6111 0C 11.6111 -0.276142 11.3873 -0.5 11.1111 -0.5L 11.1111 0.5ZM 0 0.5L 11.1111 0.5L 11.1111 -0.5L 0 -0.5L 0 0.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2_stroke",
    d: "M 0.5 0C 0.5 -0.276142 0.276142 -0.5 0 -0.5C -0.276142 -0.5 -0.5 -0.276142 -0.5 0L 0.5 0ZM -0.5 11.1111C -0.5 11.3873 -0.276142 11.6111 0 11.6111C 0.276142 11.6111 0.5 11.3873 0.5 11.1111L -0.5 11.1111ZM -0.5 0L -0.5 11.1111L 0.5 11.1111L 0.5 0L -0.5 0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.6accc95262c4b7516dfe788e2dceb1a7.svg";
export { ForwardRef as ReactComponent };